// Mixin to handle ref mapping for filtered v-for lists
// Solves Vue 2 issue where $refs array order doesn't match DOM order after filtering
export default {
  data() {
    return {
      itemRefs: new Map(),
    };
  },

  beforeUpdate() {
    // Clear refs map before re-render
    this.itemRefs.clear();
  },

  methods: {
    setItemRef(el, key) {
      if (el) {
        this.itemRefs.set(key, el);
      }
    },
  },
};
